<template>
  <task-list
    :taskList="taskList"
    :showAllTask="showAllTask"
    @clickTask="clickTask"
    @changeShowAllTask="changeShowAllTask"
  ></task-list>
</template>

<script>
import taskList from '@this/components/List/Task';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters('task', ['taskList']),
    ...mapState('task', ['showAllTask']),
  },
  methods: {
    ...mapActions('task', ['clickTask', 'changeShowAllTask']),
  },
  components: {
    taskList,
  },
};
</script>
